import { useEffect, useState } from 'react'

import PageLoading from 'components/Loading/PageLoading'

import { useDispatch } from 'react-redux'

import {
  setRemoteConfig,
  remoteConfigDefaultValues,
} from 'store/slices/remoteConfig'

import { useFirebaseRemoteConfig } from './useFirebaseRemoteConfig'
import { useBannerRemoteConfig } from './useBannerRemoteConfig'

export const RemoteConfig = ({ children }) => {
  const [loaded, setLoaded] = useState(false)
  const dispatch = useDispatch()
  const firebase = useFirebaseRemoteConfig()
  const banner = useBannerRemoteConfig()

  const isLoading = firebase.isLoading

  useEffect(() => {
    if (isLoading) return

    const newValues = {}

    Object.keys(remoteConfigDefaultValues).forEach((key) => {
      const bannerValue = banner?.data?.[key] ?? true
      const firebaseValue = firebase?.data?.[key] ?? true

      newValues[key] =
        (bannerValue && firebaseValue) || remoteConfigDefaultValues[key]
    })

    dispatch(setRemoteConfig(newValues))
    setLoaded(true)
  }, [isLoading])

  if (!loaded) {
    return <PageLoading />
  }

  return children
}
